export const PROFILE_FIELDS_TYPES = {
  EMAIL: 'email',
  PHONE_NUMBER: 'phoneNumber',
  HOME_PHONE: 'homePhone',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  MIDDLE_NAME: 'middleName',
  GENDER: 'gender',
  DOB: 'dob',
  NAME_SUFFIX: 'nameSuffix',
  MRNS: 'mrn',
  LOCAL_UID: 'local_uid', // same as mrn
  SSN: 'ssn',
  ADDRESS_1: 'address1',
  ADDRESS_2: 'address2',
  CITY: 'city',
  STATE: 'state',
  COUNTRY: 'country',
  POSTAL_CODE: 'postalCode',
  RELATION: 'relation',
  AVATAR: 'avatar',
  AGE: 'age',
  ETHNICITY: 'ethnicity',
  RACE: 'race',
  LANGUAGE: 'language',

  ROLE: 'role',
  RELATIONSHIP: 'relationship',
  TERMS_AND_CONDITIONS: 'termsAndConditions',
  LOGIN: 'login',
  EMAIL_OR_PHONE: 'emailOrPhone',
  PASSWORD: 'password',
  USERNAME: 'username',
  PASSWORD_CONFIRMATION: 'passwordConfirmation',
  ACCEPTED_PRIVACY_POLICY: 'acceptedPrivacyPolicy',
  ACCEPTED_TERMS_AND_CONDITIONS: 'termsAndConditionsAccepted',
  CARE_ROLE: 'careRole',

  REASON_TYPE: 'reasonType',
  REASON_NOTE: 'reasonNote',
  REASON_CODE: 'reason_code',
  REASON_VISIT: 'reasonVisit',

  LOCATION: 'locationId',
  SERVICE: 'serviceId',
  PROVIDER: 'providerId',
  ROOM: 'room',
  PAYMENT_STATUS: 'paymentStatus',
  START_TIME: 'startTime',
  REASON_TYPE_ID: 'reasonTypeId',
  REASON_COMMENT: 'note',
  COPAY: 'copay',

  DATE: 'date',

  CHAT_NAME: 'chatName',
  RELATIONSHIP_PRIORITY: 'relationship_priority',

  IS_HOME_LOCATION_DIFFERENT: 'isHomeLocationDifferent',
};

export const INSURANCE_ELIGIBILITY_FIELDS_TYPES = {
  MEMBER_ID: 'memberId',
  GROUP_NUMBER: 'groupNumber',
  PRIMARY_SUBSCRIBER: 'primarySubscriber',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  DOB: 'dob',
  PHONE_NUMBER: 'phoneNumber',
  ADDRESS_1: 'address1',
  ADDRESS_2: 'address2',
  CITY: 'city',
  STATE: 'state',
  POSTAL_CODE: 'postalCode',
  DO_NOT_HAVE_INSURANCE: 'doNotHaveInsurance',
  HEALTH_PLAN: 'healthPlan',
  GENDER: 'gender',
  INSURANCE_RELATION_ID: 'insuranceRelationId',
};

export const COMPLETE_YOUR_PROFILE_FIELD_TYPES = {
  RACE: 'race',
  ETHNICITY: 'ethnicity',
  EMAIL: 'email',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  PHONE_NUMBER: 'phoneNumber',
  RELATION: 'relation',
  ADDRESS1: 'address1',
  ADDRESS2: 'address2',
  CITY: 'city',
  COUNTRY: 'country',
  STATE: 'state',
  POSTAL_CODE: 'postalCode',
  LANGUAGE: 'language',
};

export const GUARANTOR_FIELD_TYPES = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  DOB: 'dob',
  PHONE_NUMBER: 'phoneNumber',
  EMAIL: 'email',
  GENDER: 'gender',
  RELATIONSHIP: 'relationship',
  ADDRESS1: 'address1',
  ADDRESS2: 'address2',
  CITY: 'city',
  STATE: 'state',
  POSTAL_CODE: 'postalCode',
};



// WEBPACK FOOTER //
// ./src/constants/formFields.js